import React, { useState,useEffect } from 'react';
import { Checkbox, Radio, Select } from 'antd';
import FilledButton from '../../../component/FilledButton';
import {
  applicationFormat,
  applicationRules,
  startDates,
  expandedParentInfo,
  parentInfo,
  parentInfo2,
  expandedParentInfo2,
  countries,
} from '../json';
import CustomSelect from './CustomSelect';
import CustomDate from './CustomDate';
import CustomRadio from './CustomRadio';
import CustomAppInput from './CustomInput';
import CustomSpecificRadio from './CustomSpecificRadio';
import CustomSpecificCheckbox from './CustomSpecificCheckbox';
import CustomCheckbox from './CustomCheckbox'
import DateInput from './DateInput';
import { debug } from 'util';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';

const { Option } = Select;


function ApplicationInformation({
  onStepFinish,
  allOptions,
  selectLoading,
  dispatch,
  Form,
  form,
  otherOption,
  setOtherOption,
  setUserResponse,
  formSubmit
}) {
  const [formFormat, setFormFormat] = useState(applicationFormat);
  const [email, setEmail] = useState()
  const rules = applicationRules;
  const [userid, setUser] = useState();
  const [courseDate, setCourseDate] = useState();
  const userData = useSelector((state) => state.ApplicationModel.applicatio_id);
  let { id } = useParams();

  useEffect(()=>{
    const  getvalues =   form.getFieldsValue().personal_information
    if(getvalues.country === 'USA'){
      handleFilterFieldsSecond();
    }else{
      handleFilterFields();
    }
  },[])

  useEffect(()=>{
    let CourseId = allOptions.allCourse.filter((e)=>e.courseId === id )
    if(userid?.email && !userData._id ){
     dispatch.ApplicationModel.getuserId({
       email:userid.email?.toLowerCase(),
       first_name:userid.first_name,
       last_name:userid.last_name,
       course_id:CourseId[0]._id,
       setUserResponse,
     });
   }
 },[userid])

 useEffect(()=>{
  if(userData){
    const userDetails = form.getFieldsValue().course_selection
    const mergedData = { ...userDetails, ...userData };
    localStorage.setItem('userData', JSON.stringify(mergedData));
  }
},[userData, courseDate])

  const handleFilterFields = () => {
		const datamanage =  applicationFormat[1].children;
		const filteredData = datamanage.reduce((acc, item) => {
			if (item.name !== "cell_phone" && item.name !== "home_phone" && item.name !== "sms" && item.name !== "state") {
				acc.filteredItems.push(item);
			} else {
				acc.cellPhoneItems.push(item);
			}
			return acc;
		}, { filteredItems: [], cellPhoneItems: [] });

		const { filteredItems, cellPhoneItems } = filteredData;
		const mergedData = [...applicationFormat];
    mergedData[1] = { ...applicationFormat[1], children: filteredItems };
		setFormFormat(mergedData)
	}

  const handleFilterFieldsSecond = () => {
		const datamanage =  applicationFormat[1].children;

		const filteredData = datamanage.reduce((acc, item) => {
			if (item.name !== "province_county") {
				acc.filteredItems.push(item);
			} else {
				acc.cellPhoneItems.push(item);
			}
			return acc;
		}, { filteredItems: [], cellPhoneItems: [] });

		const { filteredItems, cellPhoneItems } = filteredData;
		const mergedData = [...applicationFormat];
			mergedData[1] = { ...applicationFormat[1], children: filteredItems };
		setFormFormat(mergedData)
	}

  const handleOtherOption = (e, data) => {
    if (e?.target?.value === 'other') {
      setOtherOption({ ...otherOption, [data.name]: true });
    } else {
      setOtherOption({ ...otherOption, [data.name]: false });
    }
  };

  const handleCheckOtherOption = (e, data) => {
    if (e?.includes('other')) {
      setOtherOption({ ...otherOption, [data.name]: true });
    } else {
      setOtherOption({ ...otherOption, [data.name]: false });
    }
  };

  const renderOptions = (type) => {
    switch (type) {
      case 'allCourse':
        return (
          <>
            {allOptions[type].map((value) => {
              return <Option value={value.courseId}>{value.name}</Option>;
            })}
          </>
        );
      case 'courseDate': {
        return (
          <>
            {allOptions[type].map((value) => {
              return <Option value={value}>{value}</Option>;
            })}
          </>
        );
      }
      default:
        return (
          <>
            {allOptions[type].map((value) => {
              return <Option value={value}>{value}</Option>;
            })}
          </>
        );
    }
  };

  const renderRadio = (options) => {
    return (
      <>
        {options.map((item) => {
          return <Radio value={item.label}>{item.value}</Radio>;
        })}
      </>
    );
  };

  const renderCheckbox = (options) => {
    return (
      <>
        {options.map((item) => {
          return <Checkbox value={item.label}>{item.value}</Checkbox>;
        })}
      </>
    );
  };

  const isLoader = (data) => {
    switch (data.optionKey) {
      case 'allCourse':
        return selectLoading;
      case 'courseDate':
        return selectLoading;
      default:
        return false;
    }
  };

  const onSelect = (e, data) => {
    let courseDates = allOptions.allCourse.filter(
      (data) => data.courseId === e
    )[0];
    dispatch.ApplicationModel.setCustomDates({
      name: 'courseDate',
      value: [...(courseDates?.start_date || [])]
    });
  };

  const handleTracking = (e) => { 
    if (e.target.name === "cell_phone") {
      form.validateFields([ ["personal_information", "email"], ["personal_information", "cell_phone"] ]).then(res => {
        const { cell_phone, email } = res.personal_information;
        setEmail(email)
        dispatch.ApplicationModel.trackFormInAc({
          ["phone"]: cell_phone,
          email,
          formID: 'PreCollageApplicantForm'
        });
        // dispatch.ApplicationModel.preClgEvent({
        //   ["event"]: 'Application Started',
        //   email,
        //   user_id:userData._id,
        //   course_id:userData.course_id
        // });
      })
    } 
    else if(e.target.id === 'personal_information_country'){
      form.validateFields([ ["personal_information", "email"], ["personal_information", "country"] ]).then(res => { 
        const { cell_phone, email,country } = res.personal_information;
        const country_code = countries.find((e)=>e.value === country)
        dispatch.ApplicationModel.trackFormInAc({
          ["phone"]: cell_phone,
          email,
          country_code :country_code.code,
          formID: 'PreCollageApplicantForm'
        });
      })
    }
    else {
      form.validateFields([ ["personal_information", "email"] ]).then(res => {
        const { email } = res.personal_information;
        dispatch.ApplicationModel.trackFormInAc({
          email,
          formID: 'PreCollageApplicantForm'
        });
      })
      form.validateFields([ ["personal_information", "email"],["personal_information", "first_name"],["personal_information", "last_name"] ]).then(res => {
        const { email,first_name ,last_name} = res.personal_information;
        const usergetId = {email,first_name ,last_name};
        setUser(usergetId)
      })
    }

  }

 
  const selectcontriyName = (value) =>{
    setFormFormat(value === "USA" ?  ()=> handleFilterFieldsSecond() : ()=> handleFilterFields()  )
  }

  const renderChildren = (children, formEle) => {
    return children.map((data) => {
      switch (data.type) {
        case 'CustomSelect':
          return (
            <CustomSelect
              parentKey={formEle.key}
              rules={rules}
              loading={isLoader(data)}
              renderOptions={renderOptions}
              data={data}
              Form={Form}
              mode={data.mode}
              placeholder={data.placeholder}
              onSelect={onSelect}
              selectcontriyName={selectcontriyName}
              handleTracking={handleTracking}
            />
          );
        case 'DateInput':
          return (
            <DateInput
              parentKey={formEle.key}
              rules={rules}
              Form={Form}
              data={data}
            />
          );
        case 'CustomRadio':
          return (
            <CustomRadio
              parentKey={formEle.key}
              rules={rules}
              data={data}
              Form={Form}
              renderRadio={renderRadio}
            />
          );
        case 'CustomSpecificRadio':
          return (
            <CustomSpecificRadio
              parentKey={formEle.key}
              rules={rules}
              data={data}
              Form={Form}
              renderRadio={renderRadio}
              handleOtherOption={handleOtherOption}
              otherOption={otherOption}
            />
          );
        case 'CustomSpecificCheckbox':
          return (
            <CustomSpecificCheckbox
              parentKey={formEle.key}
              rules={rules}
              data={data}
              Form={Form}
              renderCheckbox={renderCheckbox}
              handleOtherOption={handleCheckOtherOption}
              otherOption={otherOption}
            />
          );
        case 'CustomDate':
          return (
            <CustomDate
              parentKey={formEle.key}
              rules={rules}
              data={data}
              Form={Form}
              disabledDate={disabledDate}
            />
          );
        case 'CustomCheckbox':
          return (
            <CustomCheckbox
            parentKey={formEle.key}
            rules={rules}
            data={data}
            Form={Form}
            renderCheckbox={renderCheckbox}
            handleOtherOption={handleCheckOtherOption}
            otherOption={otherOption}
            handleTracking={handleTracking}/>
          );
        default:
          return (
            <CustomAppInput
              parentKey={formEle.key}
              rules={rules}
              Form={Form}
              data={data}
              handleTracking={handleTracking}
            />
          );
      }
    });
  };

  const disabledDate = (current) => {
    return current.valueOf() > Date.now();
  };

  const renderFormElements = (format) => {
    return format?.map((formEle) => {
      return (
        <div className='applocant_info'>
         
          <div className='form_fill_content'>
          <h3>{formEle.title}</h3>
            {formEle.subTitle && <h4>{formEle.subTitle}</h4>}
            {renderChildren(formEle.children, formEle)}
          </div>
        </div>
      );
    });
  };

  const handleValuesChange = (e, _) => {
    if(e.course_selection?.start_date){
      setCourseDate(e.course_selection?.start_date)
    }

    const { parents_information_1, parents_information_2 } = e;
    let temp = [...formFormat];

    let index = temp.findIndex((data) => data.key === 'parents_information_1');
    let index2 = temp.findIndex((data) => data.key === 'parents_information_2');

    if (parents_information_1?.address_same_as_student === 'No') {
      temp[index].children = [...expandedParentInfo];
      setFormFormat(temp);
    } else if (parents_information_1?.address_same_as_student === 'Yes') {
      temp[index].children = [...parentInfo];
      setFormFormat(temp);
    } else if (parents_information_2?.parent_address_same_as_student === 'No') {
      temp[index2].children = [...expandedParentInfo2];
      setFormFormat(temp);
    } else if (parents_information_2?.parent_address_same_as_student === 'Yes') {
      temp[index2].children = [...parentInfo2];
      setFormFormat(temp);
    }
  };

  return (
    <div className='container'>
      <Form
        form={form}
        onFinish={(values) => onStepFinish(values, 1)}
        scrollToFirstError
        onValuesChange={handleValuesChange}
      >
        {renderFormElements(formFormat)}
        <div className='applocant_info'>
          <h3></h3>
          <div className='form_fill_content dl_program_btns'>
            <FilledButton
              loading={formSubmit}
              type='submit'
              value='Continue'
              className='btn_primary ml_1'
            />
          </div>
        </div>
      </Form>
    </div>
  );
}

export default ApplicationInformation;
